import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CancelRequestsService } from 'projects/shop/src/app/+shared/services/cancel-requests.service';
import { SelectRegionalLanguage } from 'projects/shop/src/app/layout/navbar/components/navbar-header/partials/nav-regional/store/regional-setting.selectors';
import { catchError, takeUntil, tap, throwError } from 'rxjs';

export const MaintenanceInterceptor: HttpInterceptorFn = (req, next) => {
  const cancelService = inject(CancelRequestsService);
  const router = inject(Router);
  const store = inject(Store);
  const lang = store.selectSignal(SelectRegionalLanguage);

  return next(req).pipe(
    tap(res => {
      // Response successful
    }),
    catchError((error: any) => {
      // Check if server is in maintenance mode (status 503 or error.error.message.title exists)
      if (error.status === 503 || (error?.error?.message?.title)) {
        
        // Store maintenance data if available
        if (error?.error?.message) {
          console.log('error?.error?.message?.title: ', error?.error?.message?.title);
          cancelService.maintenanceModeData.next(error.error.message);
        }

        // Cancel all pending requests
        cancelService.cancelAll();

      }

      return throwError(() => error);
    }),
    takeUntil(cancelService.onCancelPendingRequests),
  );
};

